import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import Parse from 'parse'
import {
  Route
} from 'react-router-dom'

export default class CoachMemoriesListComponent extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      memories: null
    }
    this.loadContent()
  }

  loadContent = () => {
    console.log('Loading coach memories...')
    const content = new Parse.Object('SwimCoachMemory')
    const query = new Parse.Query(content)
    query.descending('createdAt')
    query.limit(100)
    query.find().then((results) => {
      console.log('Coach memories loaded:', results.length)
      this.setState({
        memories: results
      })
    }, (error) => {
      alert('Error getting coach memories: ' + error.message)
    })
  }

  numberOfResultsText = () => {
    if (!this.state.memories) return (<i>Loading...</i>)
    if (this.state.memories.length === 100) return (<i>100+ results</i>)
    return (<i>{this.state.memories.length} results</i>)
  }

  renderTableHeader = () => {
    return (
      <tr key={'0-header'} className="data">
        <th className="bg-primary" key={'0h'}>Date Created ▾</th>
        <th className="bg-primary" key={'1h'}>Memory</th>
        <th className="bg-primary" key={'2h'}>Category</th>
        <th className="bg-primary" key={'3h'}>User</th>
      </tr>
    )
  }

  renderTable = () => {
    if (!this.state.memories) return ''
    return this.state.memories.map((memory, index) => {
      const user = memory.get('user')
      const userId = user ? user.id : null
      const category = memory.get('category')
      return (
        <tr key={index} className="data">
          <td>
            {memory.get('createdAt').toLocaleString()}
          </td>
          <td>
            {memory.get('content')}
          </td>
          <td>
            {category
              ? (<span className="badge text-bg-light">{category}</span>)
              : (<span className="text-muted">—</span>)}
          </td>
          <td>
            {userId
              ? (
                <a href={'/#/members/' + userId}>
                  <code>{userId}</code>
                </a>
                )
              : (
                <span className="text-muted">N/A</span>
                )}
          </td>
        </tr>
      )
    })
  }

  render = () => {
    return (
      <div>
        <Route path="/coachMemories">
          <div className="container">
            <br/>
            <div>
              <h1 id="title">Coach Memories</h1>
            </div>
            <br/>
            <table id="coachmemories" className="data">
              <tbody>
                {this.renderTableHeader()}
                {this.renderTable()}
              </tbody>
            </table>
            <br/>
            {this.numberOfResultsText()}
            <br/>
          </div>
        </Route>
      </div>
    )
  }
}
